import {probeSession, notifyUnauthorized} from "@/api/axios.js";
import {createManagedSSEConnection} from "./sseConnection.js";

// Wiring col browser: EventSource nativo + verifica sessione single-flight condivisa
// con Axios (che rinnova da se' solo quando serve davvero).
// Ritorna close() per il cleanup nell'useEffect degli hook.
export function openManagedSSE(url, {listeners, onOpen, onError, onFatal} = {})
{
	return createManagedSSEConnection(url, {
		listeners,
		onOpen,
		onError,
		onFatal,
		EventSourceImpl: EventSource,
		checkSession: probeSession,
		notifyUnauthorized
	});
}
